import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import noop from "ramda-extension/es/noop";
import React, { forwardRef } from 'react';
import { ListBoxItem } from '../../../organisms/ListBox';
const SelectOption = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, value, label, focused, children, selected, disabled, onClick, ...other } = props;
    return /*#__PURE__*/ React.createElement(ListBoxItem, {
        className: cx('Select-option', {
            'Select-option--focused': focused
        }, {
            'Select-option--selected': selected
        }, {
            'Select-option--disabled': disabled
        }, className),
        onClick: disabled ? noop : onClick,
        isSelectOption: true,
        ref: ref,
        value: value,
        ...other
    }, /*#__PURE__*/ React.createElement("span", {
        className: cx('Select-optionContent')
    }, children || label));
});
SelectOption.displayName = 'SelectOption';
SelectOption.propTypes = {
    /**
	 * Children will be rendered within the `Select-optionContent`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * Item is not clickable
	 */ disabled: PropTypes.bool,
    /**
	 * If true, component will have Select-option--focused class
	 */ focused: PropTypes.bool,
    /**
	 * Text displayed in the option.
	 */ label: PropTypes.string,
    /**
	 * Callback function fired when button is clicked.
	 *
	 * @param {object} event event targeting the element.
	 * @return {undefined} Nothin'
	 */ onClick: PropTypes.func,
    /**
	 * If true, component will have Select-option--selected class
	 */ selected: PropTypes.bool,
    /**
	 * Value will be passed to optionProps
	 */ value: PropTypes.any
};
export default SelectOption;
